import React, { Component } from "react";
import {
  Card,
  CardBody,

} from "reactstrap";

import AllratesPanel from "../AllRates/AllratesPanel";
import RateHistoryPanel from "./RateHistoryPanel";
const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Rate History</h1>
      <p className="mb-0 subtitle text-nowrap">
        Manage and  &nbsp;
        <span className="hidden-sm-down"> update exchange rate</span>
      </p>
    </header>
  </div>
);

class RateHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }


  render() {
    const {
      screen,
      filters,
      historyFilters,
      rateModalOpen,
      bulkModalOpen,
      editingRate,
      form,
    } = this.state;

    return (
      <div className="view exchange-rate-view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4 exchange-rate-card">
            <CardBody>
              <div>
                <h6 className="mb-0 text-uppercase pull-left">Rate History</h6>
              
                <div className="clearfix">&nbsp;</div>
                <RateHistoryPanel />
              </div>
            </CardBody>
          </Card>
        </ViewContent>
        
      </div>
    );
  }
}

export default RateHistory;



// WEBPACK FOOTER //
// ./src/views/exchange-rate/RateHistory/RateHistory.js